import React from "react";
import Hero from "./Hero";
import Posting from "./Posting";

import AboutSystem from "./AboutSystem";

function HomePage() {
  return (
    <>
      {/* <div
      style={{
        backgroundImage: "url('media/images/heroBackground.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    > */}

      <Hero />
      {/* </div> */}
      <AboutSystem />
      <Posting />
    </>
  );
}

export default HomePage;
